<template>
  <div class="sidebar sidebar-hide-to-small sidebar-shrink sidebar-gestures">
    <div class="nano">
      <div class="nano-content">
        <ul>
          <div class="logo">
            <span>Admin</span>
          </div>
          <li v-if="user.auth === 1">
            <router-link to="/">
              <i class="ti-home"></i>主報表
            </router-link>
          </li>
          <!-- <li v-if="user.auth === 1">
            <router-link to="/now">
              <i class="ti-alarm-clock"></i>即時報表
            </router-link>
          </li>-->
          <li
            v-for="dep in depAry"
            :key="dep.index"
            v-show="user.department === dep.code || user.department === 'all'"
          >
            <a data-toggle="collapse" :href="'#' + dep.code + 'Menu'" role="button">
              <i class="ti-bar-chart-alt"></i>
              {{ dep.name }}
              <span class="sidebar-collapse-icon ti-angle-down"></span>
            </a>
            <div
              class="collapse dep-content"
              :class="{ show: dep.code === mainDep }"
              :id="dep.code + 'Menu'"
            >
              <ul>
                <li v-if="user.auth === 1">
                  <router-link :to="'/compare/' + dep.code" @click.native="mainDep = dep.code">比較圖</router-link>
                </li>
                <!-- <li v-if="user.auth === 1 && dep.code == 'card'">
                  <router-link
                    :to="'/multiorder/' + dep.code"
                    @click.native="mainDep = dep.code"
                  >訂單多款數</router-link>
                </li>-->
                <!-- <li>
                  <router-link :to="'/count/' + dep.code" @click.native="mainDep = dep.code">銷售表</router-link>
                </li>-->
                <li>
                  <router-link :to="'/member/' + dep.code" @click.native="mainDep = dep.code">人員資訊</router-link>
                </li>
                <!-- <li>
                  <router-link :to="'/calendar/' + dep.code" @click.native="mainDep = dep.code">日曆</router-link>
                </li>-->
              </ul>
            </div>
          </li>
          <li v-if="user.userName === 'admin'">
            <router-link to="/setting">
              <i class="ti-settings"></i>設定
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainDep: ""
    };
  },
  created() {
    this.mainDep = this.$store.state.loginState.department;
  },
  computed: {
    user() {
      return this.$store.state.loginState.account
        ? this.$store.state.loginState
        : {};
    },
    depAry() {
      return this.$store.state.departmentAry;
    }
  }
};
</script>
<style>
.sidebar .nano-content > ul li > a {
  display: block;
  cursor: pointer;
  color: #fff !important;
  text-align: left;
  padding: 10px;
  line-height: 30px;
  border-bottom: none;
  background: #343957;
  text-decoration: none;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  position: relative;
}

.nano li .router-link-exact-active {
  background-color: #637cfd !important;
}

.dep-content li a {
  text-indent: 40px !important;
}
</style>
